/* Pokelageret: recover partial card numbers within Globo's existing collection,
   filters and sorting. Never replace ordinary text search or unrelated fetches. */
(function () {
  'use strict';
  var originalFetch = window.fetch.bind(window);
  var cache = new Map();
  function numberParts(q) {
    return String(q || '').trim().match(/^(\d{1,4})\s*\/\s*(\d{1,4})$/);
  }
  function matches(title, parts) {
    var numbers = String(title).match(/\d{1,4}\s*\/\s*\d{1,4}/g) || [];
    return numbers.some(function (n) {
      var pair = n.replace(/\s/g, '').split('/');
      return pair[0].endsWith(parts[1]) && pair[1] === parts[2];
    });
  }
  async function candidates(url, init, parts) {
    var broad = new URL(url);
    broad.searchParams.set('q', parts[2]);
    broad.searchParams.set('page', '1');
    broad.searchParams.set('limit', '100');
    broad.searchParams.delete('event');
    var key = broad.toString();
    var saved = cache.get(key);
    if (saved && Date.now() - saved.time < 30000) return saved.result;
    var products = [], seen = new Set(), page = 1, first;
    while (true) {
      broad.searchParams.set('page', String(page));
      var response = await originalFetch(broad.toString(), init);
      if (!response.ok) throw new Error('Card-number search failed');
      var data = await response.json();
      if (!Array.isArray(data.products) || !data.pagination || data.processing) throw new Error('Card-number search unavailable');
      if (!first) first = data;
      data.products.forEach(function (product) {
        if (!seen.has(product.id)) { seen.add(product.id); products.push(product); }
      });
      if (!data.pagination.hasMorePages) break;
      // Never silently return an incomplete result set.
      if (!data.products.length || page >= 50) throw new Error('Card-number search too broad');
      page++;
    }
    var result = {products: products, filters: first.filters || []};
    cache.set(key, {time: Date.now(), result: result});
    if (cache.size > 12) cache.delete(cache.keys().next().value);
    return result;
  }
  window.fetch = async function (input, init) {
    var url, parts, config = window.GloboEmbedFilterConfig;
    try {
      url = new URL(typeof input === 'string' ? input : input.url, location.href);
      var endpoint = config && config.api && new URL(config.api.url + '/api/apiFilter', location.href);
      if (!endpoint || url.origin !== endpoint.origin || url.pathname !== endpoint.pathname ||
          (init && init.method && init.method !== 'GET')) return originalFetch(input, init);
      parts = numberParts(url.searchParams.get('q'));
      if (!parts) return originalFetch(input, init);
    } catch (error) { return originalFetch(input, init); }
    var response = await originalFetch(input, init);
    if (!response.ok) return response;
    var data;
    try { data = await response.clone().json(); } catch (error) { return response; }
    // Exact results retain the app's own ranking, facets and pagination.
    if (!data.pagination || Number(data.pagination.total) !== 0 || data.processing) return response;
    try {
      var broad = await candidates(url, init, parts);
      var products = broad.products.filter(function (p) { return matches(p.title, parts); });
      if (init && init.signal && init.signal.aborted) throw new DOMException('Aborted', 'AbortError');
      var limit = Math.max(1, Number(url.searchParams.get('limit')) || Number(data.pagination.per_page) || 12);
      var page = Math.max(1, Number(url.searchParams.get('page')) || 1);
      var start = (page - 1) * limit;
      data.products = products.slice(start, start + limit);
      data.pagination = Object.assign({}, data.pagination, {
        total: products.length, from: products.length ? start + 1 : 0,
        to: Math.min(start + limit, products.length), per_page: limit,
        current_page: page, last_page: Math.max(1, Math.ceil(products.length / limit)),
        hasMorePages: start + limit < products.length
      });
      // Keep filters usable, but suppress broad-query counts which are not match counts.
      data.filters = broad.filters.map(function (f) { return Object.assign({}, f, {class: (f.class || '') + ' pkl-partial-facet'}); });
      return new Response(JSON.stringify(data), {status: 200, headers: {'Content-Type': 'application/json'}});
    } catch (error) {
      if (init && init.signal && init.signal.aborted) throw error;
      console.warn('Partial card-number search could not complete.', error);
      return response;
    }
  };
})();